import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import { TReportsListItemProps } from "../../Types";
import ReportDetail from "./report-detail";
import ET3Div from "../../core/et3-div";
import ReportTitles from "./report-titles";
import getReportDetailVisibleByIDStore from "../../stores/reports-store/ReportDetailVisibleByIDStore";

const ReportListItem = withLiteObserverAndTheme<TReportsListItemProps>(
  (props) => {
    const {
      report,
      status,
      pageName,
      eventID,
      takenActionType,
      date,
      reportNumberFromPartition,
      reportsPartitionMaxNumber,
      theme
    } = props;
    const { colors } = theme;
    const isDetailVisible = getReportDetailVisibleByIDStore(
      report.reportId
    ).isDetailVisible.get();

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="center"
        alignItems="center"
        withShadow={false}
        width={1500}
        height={70}
        color={colors.all.whiteBlue}
        style={{}}
        onClick={() => {}}
      >
        <ReportTitles
          report={report}
          status={status}
          pageName={pageName}
          eventID={eventID}
          takenActionType={takenActionType}
          date={date}
          reportNumberFromPartition={reportNumberFromPartition}
          reportsPartitionMaxNumber={reportsPartitionMaxNumber}
        />
        <ReportDetail
          report={report}
          isDetailVisible={isDetailVisible}
          status={status}
          pageName={pageName}
        />
      </ET3Div>
    );
  }
);
export default ReportListItem;
